module.exports = __webpack_public_path__ + "static/media/203_SHOT_085.73ba79cf.webp";